const awsmobile = {
  aws_project_region: 'us-east-2',
  aws_cognito_identity_pool_id: null,
  aws_cognito_region: 'us-east-2',
  aws_user_pools_id: 'us-east-2_MRo3dHQwr',
  aws_user_pools_web_client_id: '79cqor7d4eda9eo9t78rb33h0v', // Your App Client ID
};

export default awsmobile;
